import React, { useEffect, useState } from 'react'
import Header from '../components/Header';
import classes from "./GameOver.module.css";
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa6";
import { useDispatch, useSelector } from 'react-redux';
import Lottie from 'lottie-react';
import WinAnimation from "../animations/winAnimation.json";
import LoseAnimation from "../animations/loseAnimation.json";
import DrawAnimation from "../animations/drawAnimation.json";
import GameOverAnimation from "../animations/gameOver.json";
import { FaAngleRight, FaAngleDown } from "react-icons/fa6";
import { getProfile } from '../http/http';
import RewardsAnimation from "../animations/rewards.json";
import { useTranslation } from 'react-i18next';
import { removeUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';

const ReverseQuizGameOver = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const [accordian1, setAccordian1] = useState(false);
    const [accordian2, setAccordian2] = useState(false);
    const dispatch = useDispatch();

    const { opponent, opponentScore, opponentCorrectAnswer, opponentWrongAnswer } = useSelector(state => state?.persisted?.opponentPlayerSlice);
    const { user, userScore, userCorrectAnswer, userWrongAnswer, correctQuestions, wrongQuestions, answerChoosed } = useSelector(state => state?.persisted?.userPlayerSlice);

    const { selectedLanguage } = useSelector(state => state.languageSlice);

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    const [userProfile, setUserProfile] = useState(null);

    const fetchUserProfile = async () => {
        try {
            const response = await getProfile(userToken);
            setUserProfile(response?.data?.result);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        fetchUserProfile();
    }, []);

    /* PREVENT THE USER FROM CLICKING BACK BUTTON OF BROWSER... */
    useEffect(() => {
        window.history.pushState(null, null, document.URL);
        window.addEventListener("popstate", function () {
            window.history.pushState(null, null, document.URL);
        });
    }, [window]);

    return (
        <>
            <Header />

            <div className={classes.container}>
                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate("/home");
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                    <h2 className={classes.header_text}>{t("39")}</h2>
                </div>

                <div className={classes.animation_container}>
                    <Lottie animationData={userScore == opponentScore ? DrawAnimation : userScore > opponentScore ? WinAnimation : LoseAnimation} loop autoPlay className={classes.animation} />
                </div>

                <h1 className={classes.game_status_title}>{userScore == opponentScore ? t("40") : userScore > opponentScore ? t("41") : t("42")}</h1>

                <div className={classes.points_container_center}>

                    <div className={classes.user_points_container}>
                        <div className={classes.rewards_animation}>
                            <Lottie animationData={RewardsAnimation} loop autoPlay className={classes.animation_reward} />
                        </div>
                        <p className={classes.points}>{userProfile?.total_points} {t("2")}</p>
                    </div>
                </div>


                <div className={classes.game_over_stats_container}>
                    <div className={classes.final_score}>
                        <p className={classes.final_score_text}>{t("43")}</p>
                    </div>

                    <div className={classes.section_player_stats}>
                        <div className={classes.section_user_stats}>
                            <p className={classes.user_score}>
                                {userScore}
                            </p>

                            <p className={classes.user_name}>{t("1")}</p>
                        </div>

                        <div className={classes.section_user_stats}>
                            <p className={classes.opponent_score}>{opponentScore}</p>
                            <p className={classes.user_name}>{opponent?.name}</p>

                        </div>
                    </div>

                    <div className={classes.accordian_container}>
                        <div className={classes.accordian_sub_container} onClick={() => setAccordian1((prevValue) => !prevValue)}>
                            <p className={classes.accordion_text}>{t("44")} {userCorrectAnswer}</p>
                            <div className={classes.icon_container}>
                                {
                                    accordian1 ? <FaAngleDown className={classes.arrow} /> : <FaAngleRight className={classes.arrow} />
                                }

                            </div>
                        </div>

                        <div className={`${classes.accordian} ${accordian1 && classes.show}`}>
                            {
                                correctQuestions?.map((data, index) => {
                                    return (
                                        <div className={classes.accordian_item} key={index}>
                                            <p className={classes.question}>{t("45")} {data?.question}</p>
                                            <p className={classes.answer}>{t("48")} {data?.selectedOptionText}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <div className={classes.accordian_sub_container} onClick={() => setAccordian2((prevValue) => !prevValue)}>
                            <p className={classes.accordion_text}>{t("47")} {userWrongAnswer}</p>
                            <div className={classes.icon_container}>
                                {
                                    accordian2 ? <FaAngleDown className={classes.arrow} /> : <FaAngleRight className={classes.arrow} />
                                }
                            </div>
                        </div>

                        <div className={`${classes.accordian} ${accordian2 && classes.show}`}>
                            {
                                wrongQuestions?.map((data, index) => {
                                    return (
                                        <div className={classes.accordian_item} key={index}>
                                            <p className={classes.question}>{t("45")} {data?.question}</p>
                                            <p className={classes.answer}>{t("48")} {answerChoosed[index]}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>

                    </div>
                </div>


            </div>

        </>
    )
}

export default ReverseQuizGameOver;